import { useAdmin } from '@vtex/raccoon-next'
import { useIntl } from 'react-intl'
import { CURRENCY_FRACTION_DIGITS } from 'shared'

export const MAX_DECIMALS_DIGITS = 6

export function useNumbers() {
  const { formatNumberToParts, formatNumber } = useIntl()

  const { currency } = useAdmin()

  function toLocaleNumber(text: string): number {
    const parts = formatNumberToParts(1111.1)
    const group = parts.find((part) => part.type === 'group')?.value ?? '.'
    const decimal = parts.find((part) => part.type === 'decimal')?.value ?? ','
    let reversedVal = text.replace(new RegExp(`\\${group}`, 'g'), '')

    reversedVal = reversedVal.replace(new RegExp(`\\${decimal}`, 'g'), '.')
    const valueAsNumber = parseFloat(reversedVal)

    return Number.isNaN(valueAsNumber) ? 0 : +valueAsNumber
  }

  function formatPercentual(value: number, fractionDigits?: number): string {
    return formatNumber(value / 100, {
      style: 'percent',
      maximumFractionDigits: fractionDigits ?? MAX_DECIMALS_DIGITS,
    })
  }

  function formatCurrency(value: number): string {
    return formatNumber(value, {
      style: 'currency',
      currency,
      minimumFractionDigits: CURRENCY_FRACTION_DIGITS,
      maximumFractionDigits: CURRENCY_FRACTION_DIGITS,
    })
  }

  return { toLocaleNumber, formatNumber, formatPercentual, formatCurrency }
}
